/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileRar = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M20 7.586V10h-2V9h-5V4H6v16h12v-1h2v3H4V2h10.414zM15 7h1.586L15 5.414z" />
        <path d="M10.375 11.983c.598 0 1.058.138 1.38.414.322.276.483.667.483 1.173 0 .423-.131.77-.393 1.042a1.5 1.5 0 0 1-.646.393L12.452 17h-1.187L10.2 15.2l-.681-.174V17H8.45v-5.017zm-.855 2.34h.524c.418 0 .708-.053.87-.159.165-.11.247-.301.247-.572 0-.184-.037-.33-.11-.436a.583.583 0 0 0-.345-.227 2.515 2.515 0 0 0-.662-.069H9.52zM17.488 17h-1.2l-.332-1.028h-1.852L13.777 17h-1.152l1.904-5.017h1.042zm-3.093-1.938h1.267l-.638-1.973zm5.555-3.079c.598 0 1.058.138 1.38.414.322.276.482.667.482 1.173 0 .423-.13.771-.392 1.042a1.5 1.5 0 0 1-.647.393L22.026 17H20.84l-1.065-1.8-.68-.174V17h-1.07v-5.017zm-.855 2.34h.524c.418 0 .708-.053.87-.159.165-.11.247-.301.247-.572 0-.184-.036-.33-.11-.436a.583.583 0 0 0-.345-.227 2.515 2.515 0 0 0-.662-.069h-.524z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileRar as FileRar };
